/* eslint-disable no-return-assign */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function ViewTransmittalModal({ transmittalNumber }) {
  const setModal = useContext(ModalContext);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${
    c.TRANSMITTAL
  }?transmittal_no=${transmittalNumber}&bearer_token=${token}&email=${_.get(
    authProfile,
    'email'
  )}&
  ) || ""}&output=I`;

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Generated Transmittal"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewTransmittalModal.defaultProps = {
  transmittalNumber: '',
};

ViewTransmittalModal.propTypes = {
  transmittalNumber: PropTypes.string,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewTransmittalModal);
